import HeaderNotificationArea from './HeaderNotificationArea';
export default HeaderNotificationArea;


// WEBPACK FOOTER //
// ./src/components/App/Header/HeaderNotificationArea/index.js